


import {SystemDataVM} from './SystemDataVM';
export class CountryVM extends SystemDataVM {
    
    isoCode?: string;
    
}
